import type { deputy_v1_orgaccount_AuthToken } from "@deputy-ai/data-platform-api/v1/orgaccount";

export type AuthToken = deputy_v1_orgaccount_AuthToken;

export interface AuthTokenData {
  accountUid: string;
  orgUid: string;
  username: string;
  roles: string[];
  isSuperAdmin: boolean;
}

export interface JwtClaim {
  iat: number;
  exp: number;
  typ: string;
  aud: string;
  data: AuthTokenData;
}

export function parseAccessToken(
  accessToken: string | undefined
): JwtClaim | undefined {
  if (!accessToken) {
    return;
  }
  const cpns = accessToken.split(".");
  if (!cpns[1]) {
    return undefined;
  }
  try {
    if (typeof window === "undefined") {
      return JSON.parse(Buffer.from(cpns[1], "base64").toString());
    }
    const urlUnsafe = cpns[1].replace(/_/g, "/").replace(/-/g, "+");
    return JSON.parse(window.atob(urlUnsafe));
  } catch {
    return undefined;
  }
}

export function shouldRefreshAccessToken(accessToken: string): boolean {
  const jwt = parseAccessToken(accessToken);
  if (!jwt) {
    throw new Error("Invalid token");
  }
  return shouldRefresh(jwt);
}

const REFRESH_BEFORE_MS = 60 * 1000; // 1 minutes
export function shouldRefresh({ exp }: JwtClaim): boolean {
  if (!exp) {
    return false;
  }

  return exp * 1000 - REFRESH_BEFORE_MS <= Date.now();
}
